var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"btn-appstore"},[_c('a',{attrs:{"href":"https://itunes.apple.com/jp/app/pocket-curator/id1088763931?mt=8","target":"_blank"}},[_c('img',{attrs:{"src":_vm.btnImageSrc}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-71e35b99","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/atoms/BtnAppstore.vue
// module id = null
// module chunks = 